import React, { FunctionComponent } from "react";

import { useDealerPricingNotes } from "../../../stores/hooks/useDealerPricingNotes";
import { AnyOrderItem } from "../../../stores/slices/cartSlice";
import { PriceSelect } from "../../PriceSelect/PriceSelect";

type CartPrintPriceProps = {
  orderItem: AnyOrderItem;
};

export const CartPrintPrice: FunctionComponent<CartPrintPriceProps> = ({
  orderItem,
}) => {
  const notes = useDealerPricingNotes(orderItem.itemType);
  return (
    <div className="col-span-4">
      <div className="grid grid-cols-2 border border-edge rounded-tw-lg px-4 py-2">
        <PriceSelect
          // NOTE: order items come separately, so we don't have to worry about staggered
          isStaggered={false}
          itemTireSizeClassName="hidden"
          orderItem={null}
          part={orderItem.itemPart}
          promotionClassName="col-span-2"
        />
      </div>
      {notes && <div className="px-4 py-1 text-center">{notes}</div>}
    </div>
  );
};
